//Development Server
//const IP_URL = 'http://192.168.122.1:4000'

//Production server Url
const IP_URL = "https://aquatools.io/api";

export default IP_URL;

